import React from 'react';

const SchemaNeurosurgery = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is neurosurgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Neurosurgery is a specialized medical field that focuses on the diagnosis and surgical treatment of disorders related to the brain, spine, and nervous system, including tumors, injuries, and neurological diseases."
        }
      },
      {
        "@type": "Question",
        "name": "When should I consult a neurosurgeon?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You should consult a neurosurgeon if you experience symptoms like severe or persistent headaches, seizures, weakness in limbs, back pain, numbness, or after a head or spinal injury."
        }
      },
      {
        "@type": "Question",
        "name": "Which is the best hospital for neurosurgery in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HDNA Aarogyam Hospital is considered one of the best hospitals for neurosurgery in Patna, offering advanced brain and spine treatments with experienced specialists and modern technology."
        }
      },
      {
        "@type": "Question",
        "name": "What conditions are treated in neurosurgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Neurosurgery covers conditions such as brain tumors, stroke, head injuries, spine disorders (like slip disc), epilepsy, Parkinson’s disease, and congenital brain or spinal problems."
        }
      },
      {
        "@type": "Question",
        "name": "Is brain surgery safe?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, brain surgery is generally safe when performed by experienced neurosurgeons using advanced technology. The success rate depends on the patient’s condition, type of surgery, and timely treatment."
        }
      },
      {
        "@type": "Question",
        "name": "What is the cost of neurosurgery in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The cost of neurosurgery in Patna varies depending on the type of procedure, complexity, hospital facilities, and patient condition. It is best to consult the hospital for an accurate estimate."
        }
      },
      {
        "@type": "Question",
        "name": "How long does it take to recover from neurosurgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Recovery time depends on the type of surgery and the patient’s overall health. It can range from a few weeks to several months, with proper post-operative care and rehabilitation."
        }
      },
      {
        "@type": "Question",
        "name": "What is minimally invasive neurosurgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Minimally invasive neurosurgery involves performing procedures using smaller incisions, advanced tools, and imaging techniques. It results in less pain, faster recovery, and reduced hospital stay."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide emergency neurosurgery services in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, HDNA Aarogyam Hospital offers 24×7 emergency neurosurgery services for conditions like stroke, head injuries, and brain hemorrhage."
        }
      },
      {
        "@type": "Question",
        "name": "How can I book an appointment with a neurosurgeon in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can book an appointment by calling the hospital directly, visiting the website, or walking into HDNA Aarogyam Hospital for consultation with a neurosurgery specialist."
        }
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

export default SchemaNeurosurgery;